/* eslint no-restricted-globals: 0 */
import React from "react";
import { connect } from "react-redux";
import Toast from "grommet/components/Toast";
import version from "./version";
import store from "./store";

async function ensureLatestVersionIsRunning() {
  try {
    const t = Date.now();
    const res = await fetch("/meta.json?_=" + t, {
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: 0
      }
    });
    const { expectedVersion } = await res.json();
    console.log(expectedVersion, version);
    if (expectedVersion !== version) {
      store.dispatch({ type: "NEW_VERSION_AVAILABLE" });
    }
  } catch (err) {
    console.error("Failed to check for latest version:", err);
  }
}

async function getAPIState() {
  try {
    const t = Date.now();
    const res = await fetch("/api/status?_=" + t, {
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: 0
      }
    });
    const { state } = await res.json();
    store.dispatch({ type: "API_STATE_RECEIVED", payload: { state } });
  } catch (err) {
    console.error("Failed to get API state:", err);
    store.dispatch({ type: "API_STATE_RECEIVED", payload: { state: "offline" }})
  }
}

const oneDay = 24 * 60 * 60 * 1000;
const versionCheckInterval = 15 * 60 * 1000; // 15 minutes
const apiStateInterval = 30 * 1000; // 30 seconds

class StatusComponent extends React.Component {
  componentDidMount() {
    setImmediate(ensureLatestVersionIsRunning);
    setInterval(ensureLatestVersionIsRunning, versionCheckInterval);
    setImmediate(getAPIState);
    setInterval(getAPIState, apiStateInterval);
  }
  reload() {
    location.reload(true);
  }
  render() {
    const { hasNewVersion, apiState } = this.props;
    return (
      <div>
        {hasNewVersion && (
          <Toast duration={oneDay} status={"critical"}>
            <p>
              New version is available. Click <a onClick={this.reload}>here</a>{" "}
              to refresh.
            </p>
          </Toast>
        )}
        {apiState && (
          <Toast duration={oneDay} status={"critical"}>
            <p>
              API is {apiState}... This banner will disappear when it is ready
              to use.
            </p>
          </Toast>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  hasNewVersion: state.getIn(["status", "hasNewVersion"]),
  apiState: state.getIn(["status", "apiState"])
});

export default connect(mapStateToProps)(StatusComponent);



// WEBPACK FOOTER //
// ./src/Status.js